import React from 'react';
import { Image } from '../components/Image';
import { RichTextContent } from './RichTextBlock';
import './QuoteBlock.scss';
export function QuoteBlock({ data }) {
    return React.createElement("div", { className: "content-block-quote" },
        React.createElement(Image, { alt: "", image: data.value.image }),
        React.createElement(RichTextContent, { html: data.value.content }),
        React.createElement("div", { className: "quotee" },
            React.createElement("span", { className: "name" }, data.value.name),
            data.value.title ? React.createElement("span", { className: "title" }, data.value.title) : null));
}
